{
  "journalAudit.action.org.invitation.grant_added": "Assignment added to an invitation",
  "journalAudit.action.org.invitation.grant_removed": "Assignment removed from an invitation",
  "v8e.code.ALREADY_MEMBER": "The invited person is already a member.",
  "v8e.code.CONFLIT_CONCURRENT": "The invitation changed in the meantime: it has been reloaded, check it and try again.",
  "v8e.code.INVITATION_NOT_RENEWABLE": "Invitation already accepted or revoked: no new link.",
  "v8e.code.INVITATION_NOT_REVOCABLE": "Invitation already accepted or revoked.",
  "v8e.code.LAST_OWNER": "This is the project’s last active owner: appoint another owner first.",
  "v8e.code.MEMBERSHIP_NOT_FOUND": "This person is no longer a member.",
  "v8e.code.OWNERSHIP_TRANSFER_REQUIRED": "This person owns the space: transfer ownership first.",
  "v8e.code.PROFIL_INCONNU": "This profile is unknown or not published.",
  "v8e.code.PROFIL_NIVEAU_INCOMPATIBLE": "This profile does not match the level of the chosen space.",
  "v8e.code.PROGRAM_LAST_OWNER": "This is the programme’s last active owner: appoint another owner first.",
  "v8e.code.V8E_ATTRIBUTIONS_TROP_NOMBREUSES": "An invitation holds at most 50 projects or programmes.",
  "v8e.code.V8E_ATTRIBUTION_ABSENTE": "This assignment is not (or no longer) in the invitation.",
  "v8e.code.V8E_ATTRIBUTION_DEJA_PRESENTE": "This project or programme is already in the invitation.",
  "v8e.code.V8E_INVITATION_NON_EN_ATTENTE": "This invitation is no longer pending (accepted, revoked or expired): its assignments are frozen.",
  "v8e.code.WORKSPACE_ARCHIVED": "Archived project: it is read-only.",
  "v8e.invitations.action.org.invitation.accepted": "Invitation accepted",
  "v8e.invitations.action.org.invitation.created": "Invitation sent",
  "v8e.invitations.action.org.invitation.grant_added": "Assignment added",
  "v8e.invitations.action.org.invitation.grant_removed": "Assignment removed",
  "v8e.invitations.action.org.invitation.renewed": "New link sent",
  "v8e.invitations.action.org.invitation.resent": "Email resent",
  "v8e.invitations.action.org.invitation.revoked": "Invitation revoked",
  "v8e.invitations.ajout.ajouter_programme": "Add the assignment to the programme",
  "v8e.invitations.ajout.ajouter_projet": "Add the assignment to the project",
  "v8e.invitations.ajout.archive": "{{nom}} (archived, read-only)",
  "v8e.invitations.ajout.choisir": "Choose…",
  "v8e.invitations.ajout.espace_programme": "Programme",
  "v8e.invitations.ajout.espace_projet": "Project",
  "v8e.invitations.ajout.espaces_programme": "the programmes",
  "v8e.invitations.ajout.espaces_projet": "the projects",
  "v8e.invitations.ajout.invitation_visee": "Invitation for {{email}} — {{etat}}",
  "v8e.invitations.ajout.profils": "the published profiles",
  "v8e.invitations.ajout.profils_programme": "Profiles on the programme",
  "v8e.invitations.ajout.profils_projet": "Profiles on the project",
  "v8e.invitations.ajout.profils_refuses_k3": "The published profiles list requires the right to view organisation profiles: adding stays closed.",
  "v8e.invitations.ajout.type": "Type",
  "v8e.invitations.appartenance.absente": "This membership cannot be found or was already removed.",
  "v8e.invitations.appartenance.dernier_proprietaire": "Last active owner: transfer ownership first.",
  "v8e.invitations.appartenance.effet_acces": "Their access to this space is revoked immediately, with their profiles and isolated rights on it.",
  "v8e.invitations.appartenance.effet_compte": "Their account stays active in the organisation.",
  "v8e.invitations.appartenance.effets": "the effects of removal",
  "v8e.invitations.appartenance.effets_programme_k5": "No work effect is described for a programme.",
  "v8e.invitations.appartenance.effets_projet": "Assigned work: {{travail}}; designations: {{designations}}; teams: {{equipes}}.",
  "v8e.invitations.appartenance.personne": "the person",
  "v8e.invitations.appartenance.retirer_programme": "Remove from the programme",
  "v8e.invitations.appartenance.retirer_projet": "Remove from the project",
  "v8e.invitations.appartenance.visee": "Remove {{personne}} from {{nom}} ({{niveau}}).",
  "v8e.invitations.fiche.adresse": "Address",
  "v8e.invitations.fiche.ajouter_attribution": "Add a project or programme",
  "v8e.invitations.fiche.attributions": "Projects and programmes",
  "v8e.invitations.fiche.aucune_attribution": "No project or programme in this invitation.",
  "v8e.invitations.fiche.avertissement_administrateur": "This person will administer the organisation once they accept.",
  "v8e.invitations.fiche.copie": "Link copied.",
  "v8e.invitations.fiche.copier": "Copy the link",
  "v8e.invitations.fiche.courriel_envoye": "The link was sent by email.",
  "v8e.invitations.fiche.echeance": "Expires on",
  "v8e.invitations.fiche.etat": "Status",
  "v8e.invitations.fiche.historique": "Invitation history",
  "v8e.invitations.fiche.invitation": "the invitation",
  "v8e.invitations.fiche.lien": "Invitation link",
  "v8e.invitations.fiche.lien_masque": "The link can no longer be shown: create a new link if needed.",
  "v8e.invitations.fiche.lien_precedent_invalide": "The previous link no longer works.",
  "v8e.invitations.fiche.lien_une_fois": "This link is shown only once: copy it now.",
  "v8e.invitations.fiche.membre_simple": "No organisation profile: plain member.",
  "v8e.invitations.fiche.mode": "Delivery",
  "v8e.invitations.fiche.mode_courriel": "By email",
  "v8e.invitations.fiche.mode_lien": "Single-use link",
  "v8e.invitations.fiche.motif": "Reason for revocation (optional)",
  "v8e.invitations.fiche.nouveau_lien": "Create a new link",
  "v8e.invitations.fiche.profil_propose": "Proposed organisation profile",
  "v8e.invitations.fiche.retirer_attribution": "Remove {{nom}}",
  "v8e.invitations.fiche.retour_membres": "Back to members",
  "v8e.invitations.fiche.revocation": "Revocation",
  "v8e.invitations.fiche.revoquee": "Invitation revoked.",
  "v8e.invitations.fiche.revoquer": "Revoke the invitation",
  "v8e.invitations.fiche.revoquer_consequence_compte": "The never-activated account is deleted with its memberships.",
  "v8e.invitations.fiche.revoquer_consequence_lien": "The invitation link will stop working.",
  "v8e.invitations.fiche.revoquer_titre": "Revoke this invitation?",
  "v8e.invitations.fiche.sans_profil": "no profile",
  "v8e.invitations.niveau.programme": "Programme",
  "v8e.invitations.niveau.projet": "Project",
  "v8e.invitations.retrait.attribution_visee": "Remove {{nom}} ({{niveau}}, {{profils}}) from the invitation for {{email}}.",
  "v8e.invitations.retrait.retirer_programme": "Remove from the programme",
  "v8e.invitations.retrait.retirer_projet": "Remove from the project",
  "v8e.invitations.statut.acceptee": "Accepted",
  "v8e.invitations.statut.en_attente": "Pending",
  "v8e.invitations.statut.expiree": "Expired",
  "v8e.invitations.statut.revoquee": "Revoked"
}
